import React, { ComponentProps } from "react";

import { Paper } from "@/components/paper/Paper";
import { SignUpForm } from "@/features/sign-up-form/SignUpForm";

import { ModalCloseCross } from "../components/ModalCloseCross";
import { CommonModalProps } from "../models";

type PropTypes = CommonModalProps & ComponentProps<typeof SignUpForm>;

export const RegisterFormModal: React.FC<PropTypes> = ({
  onClose,
  ...signUpProps
}) => {
  const Heading = React.useCallback(() => {
    return (
      <h2 className="text-[22px] lg:text-2xl text-grey1-800 font-[680] text-center">
        Join for Free
      </h2>
    );
  }, []);

  return (
    <Paper
      data-testid="signUpModal"
      className="p-4 py-8 lg:p-8 max-w-[420px] min-h-min box-border relative"
    >
      <ModalCloseCross absolute onClose={onClose} />
      <SignUpForm
        skipHeader
        textCentered
        header={<Heading />}
        {...signUpProps}
      />
    </Paper>
  );
};
